module.exports = __webpack_public_path__ + "static/TimesLtPro-Italic-8ac2a50cb94f8fc8df39d596a3c7bdad.woff";